export const ANALYTICS_EVENT = {
	NAV: {
		PROFILE_OPEN: 'NAV_PROFILE_OPEN',
	},
	AUTH: {
		LOGIN: 'AUTH_LOGIN',
		LOGOUT: 'AUTH_LOGOUT',
	},
	BRAND: {
		HOME_CLICK: 'BRAND_HOME_CLICK',
	},
	LANGUAGE: {
		SWITCH: 'LANGUAGE_SWITCH',
	},
	TOPBAR: {
		TOKENS_CLICK: 'TOPBAR_TOKENS_CLICK',
	},
	TOKENS: {
		MODAL_OPEN: 'TOKENS_MODAL_OPEN',
		PACKAGE_SELECT: 'TOKENS_PACKAGE_SELECT',
		CHECKOUT_CLICK: 'TOKENS_CHECKOUT_CLICK',
	},
	PLAN: {
		MODAL_OPEN: 'PLAN_MODAL_OPEN',
		SELECT: 'PLAN_SELECT',
		CHECKOUT_CLICK: 'PLAN_CHECKOUT_CLICK',
	},
	HOME: {
		OPEN: 'HOME_OPEN',
		STORY_OPEN: 'HOME_STORY_OPEN',
		STORY_NEXT: 'HOME_STORY_NEXT',
		STORY_PREV: 'HOME_STORY_PREV',
		BANNER_CLICK: 'HOME_BANNER_CLICK',
		PROFILE_OPEN: 'HOME_PROFILE_OPEN',
		PROFILE_GALLERY_SLIDE: 'HOME_PROFILE_GALLERY_SLIDE',
		CHAT_START: 'HOME_CHAT_START',
		SURPRISE: 'HOME_SURPRISE',
	},
	DISCOVER: {
		OPEN: 'DISCOVER_OPEN',
		OPEN_CHAT: 'DISCOVER_OPEN_CHAT',
		BACK: 'DISCOVER_BACK',
	},
	CHAT: {
		OPEN: 'CHAT_OPEN',
		CONVERSATION_OPEN: 'CHAT_CONVERSATION_OPEN',
		MEDIA_OPEN: 'CHAT_MEDIA_OPEN',
		PROFILE_OPEN: 'CHAT_PROFILE_OPEN',
		CONVERSATION_DELETE: 'CHAT_CONVERSATION_DELETE',
		BACK_TO_LIST: 'CHAT_BACK_TO_LIST',
	},
	STUDIO: {
		OPEN: 'STUDIO_OPEN',
		STEP_SELECT: 'STUDIO_STEP_SELECT',
		BACK: 'STUDIO_BACK',
		GENERATE: 'STUDIO_GENERATE',
		REROLL: 'STUDIO_REROLL',
		AWAKEN_CONFIRM: 'STUDIO_AWAKEN_CONFIRM',
		AWAKEN: 'STUDIO_AWAKEN',
		PAYWALL_HIT: 'STUDIO_PAYWALL_HIT',
	},
	MY_SOFTIES: {
		OPEN: 'MY_SOFTIES_OPEN',
		CREATE: 'MY_SOFTIES_CREATE',
		OPEN_CHAT: 'MY_SOFTIES_OPEN_CHAT',
	},
};

export const ANALYTICS_MONETIZATION_SOURCE = {
	TOPBAR: 'topbar',
	CHAT: 'chat',
	STUDIO: 'studio',
};

export const getAnalyticsMonetizationSourceFromPath = (path) => {
	if (path?.startsWith('/chat')) {
		return ANALYTICS_MONETIZATION_SOURCE.CHAT;
	}

	if (path?.startsWith('/studio')) {
		return ANALYTICS_MONETIZATION_SOURCE.STUDIO;
	}

	return ANALYTICS_MONETIZATION_SOURCE.TOPBAR;
};

export const ANALYTICS_LANGUAGE_PLACEMENT = {
	TOPBAR: 'topbar',
	SIDEBAR: 'sidebar',
};

export const ANALYTICS_DEVICE_TYPE = {
	MOBILE: 'mobile',
	DESKTOP: 'desktop',
};
